import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['FlexProfessionalLocations']
});

const flexProfessionalLocationsApi = apiWithTags.injectEndpoints({
	tagTypes: ['FlexProfessionalLocations'],
	endpoints: (build) => ({
		flexProfessionalLocations: build.query({
			query: ({ managementCompanyId, caregiverId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/facilities`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['FlexProfessionalLocations']
		}),
		updateProfessionalLocationsStatus: build.mutation({
			query: ({ managementCompanyId, caregiverId, body }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/facilities`,
				method: 'PUT',
				body,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			invalidatesTags: ['FlexProfessionalLocations']
		})
	})
});

export const {
	useFlexProfessionalLocationsQuery,
	useUpdateProfessionalLocationsStatusMutation
} = flexProfessionalLocationsApi;
